<template>
  <div>
    <h2>{{ $t("label_administration_summary_createBusinessSummary") }}</h2>
    <div>
      {{ $t("label_administration_summary_createBusinessSummaryDescription") }}
    </div>
    <h3 class="summary-title">
      {{ $t("label_administration_summary_createBusiness") }}
    </h3>
    <summary-row
      :text="
        $t('label_administration_summary_businessCreation').replace(
          '[[businessName]]',  getAllStoreInfo.business &&
          getAllStoreInfo.business.selfAssessment_general_business_companyName
        )
      "
      :creation-status="getCreatedIds.business"
    ></summary-row>

    <h3 class="summary-title">
      {{ $t("label_administration_summary_createTags") }}
    </h3>
    <template v-for="(tag, tagIndex) in getAllStoreInfo.tagsToCreate">
      <summary-row
        :text="tag.name + ' - ' + tag.category"
        :creation-status="getCreatedIds.tags[tagIndex]"
      ></summary-row>
    </template>

    <h3 class="summary-title">
      {{ $t("label_administration_summary_assignTags") }}
    </h3>
    <h4 class="summary-subTitle">
      {{ $t("label_administration_summary_newTags") }}
    </h4>
    <summary-tags-assign
      :tags="getAllStoreInfo.tagsToCreate"
      created-ids-store-name="newTagsAssigned"
    ></summary-tags-assign>

    <h4 class="summary-subTitle">
      {{ $t("label_administration_summary_defaultTags") }}
    </h4>
    <summary-tags-assign
      :tags="getAllStoreInfo.defaultTags"
      created-ids-store-name="defaultTagsAssigned"
    ></summary-tags-assign>

    <h4 class="summary-subTitle">
      {{ $t("label_administration_summary_existingTags") }}
    </h4>
    <summary-tags-assign
      :tags="getAllStoreInfo.tags.selected"
      created-ids-store-name="selectedTagsAssigned"
    ></summary-tags-assign>

    <h3 class="summary-title">
      {{ $t("label_administration_summary_createSnapshot") }}
    </h3>
    <summary-row
      :text="$t('label_administration_summary_snapshotCreation')"
      :creation-status="getCreatedIds.snapshot"
    ></summary-row>

    <h3 class="summary-title">
      {{ $t("label_administration_summary_createSelfAssessment") }}
    </h3>
    <summary-row
      :text="$t('label_administration_summary_selfAssessmentCreation')"
      :creation-status="getCreatedIds.assessment"
    ></summary-row>

    <h3 class="summary-title">
      {{ $t("label_administration_summary_rolesCreation") }}
    </h3>

    <template v-for="(role, roleIndex) of getAllStoreInfo.roles">
      <summary-row
        :text="role.name"
        :creation-status="getCreatedIds.roles && getCreatedIds.roles[roleIndex]"
      ></summary-row>

      <summary-row
        v-if="getAllStoreInfo && getAllStoreInfo.roleTemplates[roleIndex]"
        :text="
          'Creating Access Controls ' +
          getAllStoreInfo.roleTemplates[roleIndex].ruledBy +
          ' ' +
          getAllStoreInfo.roleTemplates[roleIndex].ruledByValue.name
        "
        :creation-status="getCreatedIds.roleTemplates[roleIndex]"
      ></summary-row>
    </template>

    <h3 class="summary-title">
      {{ $t("label_administration_summary_usersCreation") }}
    </h3>

    <template v-for="(user, userIndex) of getAllStoreInfo.users">
      <summary-row
        :text="user.username"
        :creation-status="getCreatedIds.users[userIndex]"
      ></summary-row>
    </template>

    <!--    <template v-for="(user, userIndex) of getAllStoreInfo.users">
      <template
        v-for="(accountRole, accountRoleIndex) of getAllStoreInfo.accountRoles[
          userIndex
        ].selected"
      >
        <summary-row
          v-if="getCreatedIds.userAccountRoles[userIndex]"
          :key="randomKey + 'a' + accountRoleIndex  + 'u'+userIndex"
          :text="'Assign role ' + accountRole.name + ' to ' + user.username"
          :creation-status="getCreatedIds.userAccountRoles[userIndex][accountRoleIndex]"
        ></summary-row>
      </template>
    </template>-->
  </div>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { mapGetters } from "vuex";
import SummaryTagsAssign from "@/components/modules/administration/businessCreation/tabs/SummaryTagsAssign";
import SummaryRow from "@/components/modules/administration/businessCreation/tabs/SummaryRow";

export default {
  name: "SummaryTab",
  components: { SummaryTagsAssign, SummaryRow },
  props: {},
  data: function (){
    return {
      randomKey:'1234'
    }
  },
  mounted() {
    this.randomKey = this.uuidv4()
    },
  watch: {
    getCreatedIds:{
      handler: function (){
this.randomKey = this.uuidv4()
      },
      deep: true,
    }
  },
  methods: {
     uuidv4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}
  },
  computed: {
    ...mapGetters(["getTagsToCreate", "getAllStoreInfo", "getCreatedIds"]),
  },
};
</script>

<style lang="scss" scoped>
.new-id {
  font-size: 11px;
  color: gray;
}

.error {
  color: red;
}

.ok {
  color: green;
}

.message-error {
  font-size: 16px;
  color: red;
  text-align: center;
  padding: 30px;
}

.delete-tab {
  color: red;
  font-weight: bold;
  margin-left: 5px;
  padding: 2px 5px;
  font-size: 15px;
  transition: 0.3s;

  &:hover {
    font-size: 13px;
  }
}
.summary-title, .summary-subTitle{
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
